import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installBuildRefreshHandlers } from "@/buildRefresh";
import { captureReferralFromUrl } from "@/lib/referral";

// Capture a referral code (`?ref=`) at the earliest possible moment — before
// React or the router mount. Some entry URLs (e.g. `/` -> `/login`) redirect
// and drop the query string before any component effect runs, which silently
// lost the referral. Persisting it here removes that race and covers every
// entry route. Later login paths read the SAME stored value; this only makes
// the capture earlier and more robust.
captureReferralFromUrl();

const userAgent = window.navigator.userAgent || "";
const isAndroidWebView = /Android/i.test(userAgent) && /; wv\)|\bwv\b|Version\/\d+\.\d+ Chrome/i.test(userAgent);
const isEmbeddedWebView = Boolean(window.ReactNativeWebView || window.AndroidInterface || isAndroidWebView);

if (isEmbeddedWebView) {
  document.documentElement.classList.add("harday-webview");
}

installBuildRefreshHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
